/* SemBot · icona deterministica della strategia
 *
 * Griglia 5x5 specchiata sull'asse verticale, colore dalla famiglia del nome,
 * motivo dall'hash del nome completo.
 *
 * Due cose che non sono negoziabili, e perche':
 *
 * 1. UNICITA' GARANTITA, NON SPERATA. Un hash puro collide: su 65 nomi con
 *    famiglie affollate (SEM26*, SEMX*, RSIBullBear*) le collisioni arrivano
 *    davvero. Qui il registro viene costruito sull'elenco reale e, quando due
 *    motivi coincidono, ri-semina finche' la firma e' distinta. `check()`
 *    verifica che le firme distinte siano quante i nomi.
 *
 * 2. NIENTE VERDE, NIENTE ROSSO, NIENTE TEAL. In questa interfaccia il verde e
 *    il rosso significano guadagno e perdita, e il teal e' il marchio: un'icona
 *    che li usa suggerisce un giudizio che l'icona non puo' dare.
 *
 * Uso:
 *   SemBotIcon.setNames([...])          // una volta, con l'elenco reale
 *   SemBotIcon.tile(React, nome, 26)    // elemento React
 *   SemBotIcon.info(nome)               // { family, variant, color, cells }
 *   SemBotIcon.check()                  // { total, uniqueSignatures, families, ok }
 */
(function (global) {
  'use strict';

  /* ---------------------------------------------------------------------------
   * COLORI DELLE FAMIGLIE
   *
   * Prima erano PALETTE[hash(famiglia) % n]: l'hash sceglie a caso, quindi due
   * famiglie possono cadere su tinte vicine — e capitava proprio a SEM, SEM26 e
   * SEM26C, che sono quelle che si vedono affiancate.
   *
   * Ora l'assegnazione avviene sull'INSIEME delle famiglie: si ordinano in
   * modo stabile e si cammina negli ancoraggi con un passo ampio e coprimo,
   * cosi' le famiglie alfabeticamente vicine (SEM, SEM26, SEM26C) ricevono
   * colori distanti. Oltre il numero di ancoraggi si passa a una tonalita' piu'
   * scura o piu' chiara dello stesso ancoraggio, che resta distinguibile.
   *
   * Il giro completo delle tinte non e' disponibile: verde e rosso significano
   * guadagno e perdita, il teal e' il marchio. Restano blu, indaco, viola,
   * fucsia, magenta, ciano e ardesia.
   * ------------------------------------------------------------------------- */
  var ANCHORS = [
    { a: '#2f6fe0', b: '#9dc4ff' }, { a: '#c026d3', b: '#f2a8fb' },
    { a: '#0891b2', b: '#7fe0f2' }, { a: '#7c3aed', b: '#cbb2fd' },
    { a: '#db2777', b: '#fbb0cf' }, { a: '#4338ca', b: '#b4b9f7' },
    { a: '#0284c7', b: '#8fd3fb' }, { a: '#a21caf', b: '#eeaaf5' },
    { a: '#64748b', b: '#cbd5e1' }, { a: '#6366f1', b: '#c3c7fe' },
    { a: '#0e7490', b: '#67e8f9' }, { a: '#9333ea', b: '#d9b4fb' },
    { a: '#1d4ed8', b: '#a8c8ff' }, { a: '#475569', b: '#a8b6c8' },
  ];
  var STRIDE = 5; /* coprimo con 14: le famiglie vicine finiscono lontane */

  /* Distanza percettiva (Lab, CIE76): serve per SCEGLIERE i colori, non per
     sperare che l'hash li separi. dE 10 = distinguibili, 20+ = netti. */
  function toLab(hex) {
    var r = parseInt(hex.slice(1, 3), 16) / 255, g = parseInt(hex.slice(3, 5), 16) / 255, b = parseInt(hex.slice(5, 7), 16) / 255;
    function lin(v) { return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    r = lin(r); g = lin(g); b = lin(b);
    var X = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var Y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var Z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    function f(t) { return t > 0.008856 ? Math.cbrt(t) : (7.787 * t + 16 / 116); }
    var fx = f(X / 0.9505), fy = f(Y), fz = f(Z / 1.089);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }
  function dE(h1, h2) {
    var A = toLab(h1), B = toLab(h2);
    return Math.sqrt(Math.pow(A[0] - B[0], 2) + Math.pow(A[1] - B[1], 2) + Math.pow(A[2] - B[2], 2));
  }

  function shade(hex, amt) {
    var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    function mix(v) {
      var t = amt < 0 ? 0 : 255;
      var k = Math.abs(amt);
      return Math.max(0, Math.min(255, Math.round(v + (t - v) * k)));
    }
    return '#' + [mix(r), mix(g), mix(b)].map(function (v) { return v.toString(16).padStart(2, '0'); }).join('');
  }
  /* Tutti i colori disponibili: ancoraggi per tre tonalita'. */
  function candidatePool() {
    var out = [];
    for (var t = 0; t < 3; t++) {
      for (var i = 0; i < ANCHORS.length; i++) {
        var base = ANCHORS[i];
        if (t === 0) out.push({ a: base.a, b: base.b });
        else if (t === 1) out.push({ a: shade(base.a, -0.34), b: shade(base.b, -0.22) });
        else out.push({ a: shade(base.a, 0.26), b: shade(base.b, 0.14) });
      }
    }
    return out;
  }
  /* Assegnazione a punto piu' lontano: per ogni famiglia si prende il colore che
     MASSIMIZZA la distanza minima da quelli gia' assegnati. Deterministico
     perche' l'ordine delle famiglie e' stabile. */
  function assignColors(families) {
    var pool = candidatePool();
    var taken = [], out = {};
    for (var i = 0; i < families.length; i++) {
      var bestIdx = -1, bestScore = -1;
      for (var p = 0; p < pool.length; p++) {
        if (pool[p].used) continue;
        var worst = Infinity;
        for (var k = 0; k < taken.length; k++) {
          var d = dE(pool[p].a, taken[k]);
          if (d < worst) worst = d;
        }
        if (worst === Infinity) worst = 1e6 - p; /* primo: il primo ancoraggio */
        if (worst > bestScore) { bestScore = worst; bestIdx = p; }
      }
      if (bestIdx < 0) bestIdx = i % pool.length;
      pool[bestIdx].used = true;
      taken.push(pool[bestIdx].a);
      out[families[i]] = { a: pool[bestIdx].a, b: pool[bestIdx].b };
    }
    return out;
  }

  function colorForIndex(i) {
    var n = ANCHORS.length;
    var tier = Math.floor(i / n);
    var base = ANCHORS[(i * STRIDE) % n];
    if (tier === 0) return { a: base.a, b: base.b };
    if (tier === 1) return { a: shade(base.a, -0.34), b: shade(base.b, -0.22) };
    return { a: shade(base.a, 0.26), b: shade(base.b, 0.14) };
  }

  function hash(str) {
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return h >>> 0;
  }
  function seq(seed) {
    var s = seed >>> 0;
    return function () {
      s = (s + 0x6D2B79F5) >>> 0;
      var t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function buildTrie(list) {
    var root = { ch: {}, count: 0, term: false };
    for (var i = 0; i < list.length; i++) {
      var up = list[i].replace(/_/g, '');
      var node = root;
      node.count++;
      for (var j = 0; j < up.length; j++) {
        var c = up[j];
        if (!node.ch[c]) node.ch[c] = { ch: {}, count: 0, term: false };
        node = node.ch[c];
        node.count++;
      }
      node.term = true;
    }
    return root;
  }

  /* Nodo piu' profondo che sia una famiglia sensata. Tre requisiti, tutti
     ricavati dai dati e non da un elenco di prefissi:
       - condiviso da almeno 2 nomi
       - lungo almeno 3 caratteri (evita famiglie tipo "S" o "Ad")
       - preferibilmente tagliato su un confine di classe (lettera→cifra,
         maiuscola→minuscola) oppure su un nome che e' radice di altri
     Se nessun candidato e' su un confine pulito si usa il piu' profondo
     comunque valido; se non ce n'e' nessuno, il nome fa famiglia da solo. */
  /* Tre classi di carattere: cifra, maiuscola, minuscola. Il passaggio fra due
     classi e' un confine di parola ricavato dal nome stesso — e' cio' che
     distingue SEM|Flow da SEMF|low, e Sem|Flash da SEM|Flow. */
  function classOf(c) { return /[0-9]/.test(c) ? 'd' : (/[A-Z]/.test(c) ? 'U' : 'l'); }
  function familyOf(name, trie) {
    var raw = name.replace(/_/g, '');
    var up = raw;
    var node = trie, best = null, bestClean = null;
    for (var j = 0; j < up.length; j++) {
      node = node.ch[up[j]];
      if (!node) break;
      var len = j + 1;
      var kids = Object.keys(node.ch).length;
      var isRootName = node.term && kids >= 1;
      var branch = kids >= 2 || isRootName;
      if (node.count < 2 || len < 3 || !branch) continue;
      if (len > up.length) break;
      best = len;
      var clean = (len === raw.length) || isRootName ||
        (len < raw.length && classOf(raw[len - 1]) !== classOf(raw[len]));
      if (clean) bestClean = len;
    }
    var cut = bestClean != null ? bestClean : best;
    return cut == null ? name : raw.slice(0, cut);
  }

  /* 15 celle indipendenti (colonne 0,1,2) specchiate a destra.
     Densita' vincolata: una griglia quasi vuota o quasi piena non si riconosce. */
  function cellsFor(name, salt) {
    var r = seq(hash(name + (salt ? '#' + salt : '')));
    var cells, on, guard = 0;
    do {
      cells = [];
      on = 0;
      for (var i = 0; i < 15; i++) {
        var v = r();
        var s = v < 0.42 ? 0 : (v < 0.78 ? 1 : 2);
        cells.push(s);
        if (s) on++;
      }
      guard++;
    } while ((on < 6 || on > 12) && guard < 40);
    return cells;
  }

  var NAMES = [];
  var REG = null;
  var TRIE = null;

  function parse(name) {
    if (!TRIE) TRIE = buildTrie(NAMES.length ? NAMES : [name]);
    var fam = familyOf(name, TRIE);
    return { family: fam, variant: name.slice(fam.length) };
  }

  function build() {
    var list = NAMES.slice().sort();
    TRIE = buildTrie(list);
    /* prima passata: famiglia di ogni nome, poi i colori sull'insieme */
    var fams = [], famOf = {};
    for (var f0 = 0; f0 < list.length; f0++) {
      var pf = parse(list[f0]);
      famOf[list[f0]] = pf.family;
      if (fams.indexOf(pf.family) < 0) fams.push(pf.family);
    }
    fams.sort();
    var famColor = assignColors(fams);

    var used = {}, map = {};
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      var p = parse(n);
      var color = famColor[p.family];
      var salt = 0, cells, sig;
      /* ri-semina finche' la firma (motivo + colore) e' distinta */
      do {
        cells = cellsFor(n, salt);
        sig = cells.join('') + '|' + color.a;
        salt++;
      } while (used[sig] && salt < 200);
      used[sig] = n;
      map[n] = { family: p.family, variant: p.variant, color: color, cells: cells, sig: sig };
    }
    /* Passata di pulizia: una famiglia con un solo membro effettivo non e' una
       famiglia, e il prefisso troncato ("RSIB", "SMA") sarebbe un'etichetta
       fuorviante. In quel caso la strategia fa famiglia col proprio nome. */
    var effective = {};
    for (var q = 0; q < list.length; q++) { var fq = map[list[q]].family; effective[fq] = (effective[fq] || 0) + 1; }
    for (var w = 0; w < list.length; w++) {
      var nw = list[w];
      if (effective[map[nw].family] === 1 && map[nw].family !== nw) {
        map[nw].family = nw;
        map[nw].variant = '';
      }
    }
    var sigs = Object.keys(map).map(function (k) { return map[k].sig; });
    var fams = {};
    Object.keys(map).forEach(function (k) { fams[map[k].family] = 1; });
    REG = {
      map: map,
      total: list.length,
      uniqueSignatures: sigs.filter(function (s, i) { return sigs.indexOf(s) === i; }).length,
      families: Object.keys(fams).length,
    };
    REG.ok = REG.uniqueSignatures === REG.total;
    return REG;
  }
  function reg() { if (!REG) build(); return REG; }

  function info(name) {
    var r = reg();
    if (r.map[name]) return r.map[name];
    /* nome fuori elenco: comunque deterministico, senza garanzia di unicita' */
    var p = parse(name);
    return { family: p.family, variant: p.variant, color: colorForIndex(hash(p.family) % ANCHORS.length), cells: cellsFor(name, 0), sig: null };
  }

  var cache = {};
  function tile(React, name, size, opts) {
    opts = opts || {};
    var key = name + '@' + size + (opts.flat ? 'f' : '');
    if (cache[key]) return cache[key];
    var d = info(name);
    var H = React.createElement;
    var els = [];
    if (!opts.flat) {
      els.push(H('rect', { key: 'bg', x: 0, y: 0, width: 64, height: 64, rx: 14, fill: '#131a24' }));
    }
    var cell = 10, pad = 7, gap = 1.4;
    for (var col = 0; col < 3; col++) {
      for (var row = 0; row < 5; row++) {
        var s = d.cells[col * 5 + row];
        if (!s) continue;
        var fill = s === 1 ? d.color.a : d.color.b;
        var xs = col === 2 ? [2] : [col, 4 - col];
        for (var k = 0; k < xs.length; k++) {
          els.push(H('rect', {
            key: 'c' + col + row + k,
            x: pad + xs[k] * cell + gap / 2,
            y: pad + row * cell + gap / 2,
            width: cell - gap, height: cell - gap,
            rx: 2, fill: fill,
          }));
        }
      }
    }
    var el = H('svg', {
      width: size, height: size, viewBox: '0 0 64 64',
      'aria-label': name,
      style: { display: 'block', borderRadius: Math.round(size * 0.22) + 'px', flex: '0 0 auto' },
    }, els);
    cache[key] = el;
    return el;
  }

  global.SemBotIcon = {
    setNames: function (list) { NAMES = (list || []).slice(); REG = null; TRIE = null; cache = {}; return this; },
    tile: tile,
    info: info,
    parse: parse,
    check: function () {
      var r = reg();
      var cols = {}, list = [];
      Object.keys(r.map).forEach(function (n) { var f = r.map[n].family; if (!cols[f]) { cols[f] = 1; list.push(r.map[n].color.a); } });
      var min = Infinity, pair = null;
      for (var i = 0; i < list.length; i++) for (var j = i + 1; j < list.length; j++) {
        var d = dE(list[i], list[j]);
        if (d < min) { min = d; pair = [list[i], list[j]]; }
      }
      return { total: r.total, uniqueSignatures: r.uniqueSignatures, families: r.families, ok: r.ok, minColorDistance: Math.round(min), closestPair: pair };
    },
    palette: function () { return ANCHORS.slice(); },
    families: function () {
      var r = reg(), out = {};
      Object.keys(r.map).forEach(function (n) {
        var f = r.map[n].family;
        if (!out[f]) out[f] = { family: f, color: r.map[n].color.a, members: [] };
        out[f].members.push(n);
      });
      return Object.keys(out).sort().map(function (k) { return out[k]; });
    },
  };
})(typeof window !== 'undefined' ? window : this);
